<template>
  <div class="chat_room_quotation_item">
    <div class="chat_table_box">
      <div class="chat_table_ttl">견적서</div>
      <div class="chat_table_sub">예상 견적을 보내드립니다!</div>
    </div>
    <div class="chat_table_box">
      <div class="chat_table_ttl">
        <div class="color_1">
          {{ quotationModel.telecomName
          }}<span class="color_3 font_normal" v-if="!cheapPhone"
            >({{ selectedPolicyName }})</span
          >
          <span class="color_2"> / </span>
        </div>
        <div class="color_1">
          {{ quotationModel.modelName }}
          <span class="color_3 font_normal"
            >({{ quotationModel.deviceName }})</span
          >
        </div>
      </div>
    </div>
    <div class="chat_table_box">
      <dl>
        <dt>출고가</dt>
        <dd class="color_1 font_normal">
          {{ toCurrency(quotationModel.factoryPrice.toString()) }}원
        </dd>
      </dl>
      <dl>
        <dt>매장 특별 할인</dt>
        <dd class="error font_normal">
          {{ toCurrency(quotationModel.storeSupportMoney.toString()) }}원
        </dd>
      </dl>
      <dl>
        <dt>할부원금</dt>
        <dd class="color_1 font_normal">
          {{ toCurrency(this.deviceDivMonthOriginPrice.toString()) }}원
        </dd>
      </dl>
      <dl>
        <dt>월 할부금</dt>
        <dd class="color_4 font_normal">
          {{ toCurrency(this.deviceDivMonthPrice) }}원
        </dd>
      </dl>
    </div>
    <div class="chat_table_box">
      <dl>
        <dt>{{ quotationModel.planName }}</dt>
        <dd class="color_1 font_normal">
          {{ toCurrency(quotationModel.price.toString()) }}원
        </dd>
      </dl>
      <dl v-if="!cheapPhone && this.welfareMoney > 0">
        <dt class="">복지할인</dt>
        <dd class="color_1 font_normal">
          <span v-if="this.welfareMoney > 0">-</span
          >{{ toCurrency(this.welfareMoney) }}원
        </dd>
      </dl>
      <dl>
        <dt class="">월 요금</dt>
        <dd class="color_4">{{ toCurrency(this.monthPrice) }}원</dd>
      </dl>
    </div>
    <div class="chat_table_box top_line">
      <dl style="margin-bottom:0.8rem">
        <dt class="black bold">월 납부 금액</dt>
        <dd class="error">{{ toCurrency(this.monthEstimatedPrice) }}원</dd>
      </dl>
      <dl v-if="!cheapPhone && quotationModel.planTypeName">
        <dt class="black bold">유지 기간 이후</dt>
        <dd class="color_6">
          {{ toCurrency(this.changeMonthEstimatedPrice) }}원
        </dd>
      </dl>
    </div>
    <div class="chat_table_box">
      <div class="chat_table_sub ellipsis">
        {{ quotationModel.info }}
      </div>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
export default {
  props: {
    quotationModel: Object,
  },
  data() {
    return {
      cheapPhone: true,
      optionalAgreementMonthPrice: 0, // 선택약정 월 지원금
      optionalAgreementTotalPrice: 0, // 선택약정 총 지원금
      monthPrice: 0, // 월 요금
      deviceDivMonthOriginPrice: 0, // 단말 할부원금
      totalCommission: 0, // 총 할부이자
      monthCommission: 0, // 월 할부이자
      deviceDivMonthPrice: 0, // 단말기 월 할부금
      deviceMonthOriginPrice: 0, // 단말기 월 원금
      monthEstimatedPrice: 0, // 월별 예상 금액
      contractDcMoney: 0, // 약정할인 금액
      baseMoney: 0, // 베이스 요금
      welfareMoney: 0, // 복지할인 금액
      changeOptionalAgreementMonthPrice: 0, // 선택약정 월 지원금 (변경요금제로 구한 금액)
      changeOptionalAgreementTotalPrice: 0, // 선택약정 총 지원금 (변경요금제로 구한 금액)
      changeMonthPrice: 0, // 월 요금 (변경요금제로 구한 금액)
      changeBaseMoney: 0, // 베이스 요금 (기간유지이후 변경요금제로 구한 금액)
      changeWelfareMoney: 0, // 복지할인 금액 (기간유지이후 변경요금제로 구한 금액)
      changeMonthEstimatedPrice: 0, // 월별 예상 금액 (변경요금제로 구한 금액)
      diffPrice: 0,
      recommendTypeName: '',
      disclosureSupportPrice: 0,
      optionalAgreementPrice: 0,
      interestRate: 5.9,
      policyList: [
        { text: '공시지원', value: 1 },
        { text: '선택약정', value: 2 },
      ],
      telecomInfo: [
        { telecomId: 'SKT', isCheapPhone: false },
        { telecomId: 'KT', isCheapPhone: false },
        { telecomId: 'LGUPLUS', isCheapPhone: false },
        { telecomId: 'HELLOSKT', isCheapPhone: true },
        { telecomId: 'HELLOKT', isCheapPhone: true },
        { telecomId: 'HELLOUPLUS', isCheapPhone: true },
        { telecomId: '7MOBILE', isCheapPhone: true },
        { telecomId: 'MMOBILE', isCheapPhone: true },
        { telecomId: 'UPLUSE', isCheapPhone: true },
        { telecomId: 'SKYLIFE', isCheapPhone: true },
      ],
    };
  },
  mounted() {
    console.log('this.quotationModel.....');
    console.log(this.quotationModel);
    this.selectedPolicy = this.quotationModel.policy || this.selectedPolicy;

    this.selectPolicy(this.quotationModel.policy);
    this.selectedPolicyName =
      this.quotationModel.policyName || this.selectedPolicyName;
    this.cheapPhone = this.isCheapPhone();

    this.supportMoney = this.quotationModel.supportMoney;

    // 복지 할인 금액 (선택한 요금으로 처리)
    this.setWelfareMoney(this.selectedPolicy);
    this.setPrice(this.selectedPolicy);

    // 기간 유지 이후 선택한 요금이 있고 알뜰폰이 아닌경우
    if (this.quotationModel.planTypePrice && !this.cheapPhone) {
      // 복지 할인 금액 (기간유지 이후 선택한 요금으로 처리)
      this.setChangeWelfareMoney(this.selectedPolicy);
      this.setChangePrice(this.selectedPolicy);
    }

    this.disclosureSupportPrice = this.getTotalPrice(1);
    this.optionalAgreementPrice = this.getTotalPrice(2);

    if (this.disclosureSupportPrice > this.optionalAgreementPrice) {
      this.recommendTypeName = '선택약정';
    } else {
      this.recommendTypeName = '공시지원';
    }
    this.diffPrice = Math.abs(
      this.disclosureSupportPrice - this.optionalAgreementPrice,
    );
  },
  methods: {
    toCurrency(val) {
      return util.toCurrency(val);
    },
    selectPolicy(policy) {
      if (policy === 'SUPPORT_AMT') policy = 1;
      else if (policy === 'FEE_DISCOUNT') policy = 2;
      console.log(policy);
      this.selectedPolicy = policy;
      this.selectedPolicyName = this.policyList.find(
        item => item.value === policy,
      ).text;
    },

    isCheapPhone() {
      const telecomId = this.quotationModel.telecomId;
      const foundInfo = this.telecomInfo.find(
        info => info.telecomId === telecomId,
      );

      return foundInfo.isCheapPhone;
    },

    setWelfareMoney(policy) {
      const isCheap = this.isCheapPhone();

      if (policy === 1 || isCheap) {
        this.optionalAgreementMonthPrice = 0;
      } else {
        this.optionalAgreementMonthPrice = this.quotationModel.price * 0.25;
      }
      // 복지할인 금액 구하기
      if (this.quotationModel.welfareId) {
        // 베이스 요금 구하기
        if (this.quotationModel.welfareId == 'PENSION') {
          this.baseMoney =
            this.quotationModel.price -
            this.contractDcMoney -
            this.optionalAgreementMonthPrice;
        } else if (this.quotationModel.welfareId == 'BASIC1') {
          this.baseMoney = this.quotationModel.price - this.contractDcMoney;
        } else if (
          this.quotationModel.welfareId == 'BASIC2' ||
          this.quotationModel.welfareId == 'SECOND'
        ) {
          this.baseMoney = this.quotationModel.price;
        } else {
          this.baseMoney = this.quotationModel.price - this.contractDcMoney;
        }

        // 복지할인 금액 구하기
        this.welfareMoney =
          this.quotationModel.welfareFixedAmount +
          (this.baseMoney - this.quotationModel.welfareFixedAmount) *
            (this.quotationModel.welfareFixedRate / 100);
        if (this.quotationModel.welfareMaxAmount > 0) {
          if (this.welfareMoney > this.quotationModel.welfareMaxAmount) {
            this.welfareMoney = this.quotationModel.welfareMaxAmount;
          }
        }

        if (this.welfareMoney > this.baseMoney) {
          this.welfareMoney = this.baseMoney;
        }

        this.welfareMoney = Math.round(this.welfareMoney / 10) * 10;
      }
    },

    setChangeWelfareMoney(policy) {
      const isCheap = this.isCheapPhone();

      if (policy === 1 || isCheap) {
        this.changeOptionalAgreementMonthPrice = 0;
      } else {
        this.changeOptionalAgreementMonthPrice =
          this.quotationModel.planTypePrice * 0.25;
      }
      // 복지할인 금액 구하기
      if (this.quotationModel.welfareId) {
        // 베이스 요금 구하기
        if (this.quotationModel.welfareId == 'PENSION') {
          this.changeBaseMoney =
            this.quotationModel.planTypePrice -
            this.contractDcMoney -
            this.changeOptionalAgreementMonthPrice;
        } else if (this.quotationModel.welfareId == 'BASIC1') {
          this.changeBaseMoney =
            this.quotationModel.planTypePrice - this.contractDcMoney;
        } else if (
          this.quotationModel.welfareId == 'BASIC2' ||
          this.quotationModel.welfareId == 'SECOND'
        ) {
          this.changeBaseMoney = this.quotationModel.planTypePrice;
        } else {
          this.changeBaseMoney =
            this.quotationModel.planTypePrice - this.contractDcMoney;
        }

        // 복지할인 금액 구하기
        this.changeWelfareMoney =
          this.quotationModel.welfareFixedAmount +
          (this.changeBaseMoney - this.quotationModel.welfareFixedAmount) *
            (this.quotationModel.welfareFixedRate / 100);
        if (this.quotationModel.welfareMaxAmount > 0) {
          if (this.changeWelfareMoney > this.quotationModel.welfareMaxAmount) {
            this.changeWelfareMoney = this.quotationModel.welfareMaxAmount;
          }
        }

        if (this.changeWelfareMoney > this.changeBaseMoney) {
          this.changeWelfareMoney = this.changeBaseMoney;
        }
      }
    },

    setChangePrice(policy) {
      const isCheap = this.isCheapPhone();

      if (policy === 1 || isCheap) {
        this.changeOptionalAgreementMonthPrice = 0;
      } else {
        this.changeOptionalAgreementMonthPrice =
          this.quotationModel.planTypePrice * 0.25;
      }

      if (policy === 1 || isCheap) {
        this.changeOptionalAgreementTotalPrice = 0;
      } else {
        this.changeOptionalAgreementTotalPrice =
          this.changeOptionalAgreementMonthPrice * 24;
      }

      // 월요금
      this.changeMonthPrice =
        this.quotationModel.planTypePrice -
        this.changeOptionalAgreementMonthPrice -
        this.changeWelfareMoney;
      this.changeMonthPrice = Math.round(this.changeMonthPrice / 10) * 10;

      // this.deviceDivMonthOriginPrice =
      //   this.quotationModel.factoryPrice -
      //   this.quotationModel.storeSupportMoney -
      //   (policy === 1 ? this.supportMoney : 0); //공시지원금(1)일 경우에만 -공시지원금

      // this.deviceDivMonthOriginPrice =
      //   this.deviceDivMonthOriginPrice < 0 ? 0 : this.deviceDivMonthOriginPrice;

      // this.deviceDivMonthPrice =
      //   (((this.deviceDivMonthOriginPrice * (this.interestRate / 100)) / 12) *
      //     Math.pow(
      //       1 + this.interestRate / 100 / 12,
      //       this.quotationModel.divMonth,
      //     )) /
      //   (Math.pow(
      //     1 + this.interestRate / 100 / 12,
      //     this.quotationModel.divMonth,
      //   ) -
      //     1);
      // this.deviceDivMonthPrice = Math.round(this.deviceDivMonthPrice / 10) * 10;

      // this.totalCommission =
      //   this.deviceDivMonthPrice * this.quotationModel.divMonth -
      //   this.deviceDivMonthOriginPrice;

      // this.monthCommission =
      //   Math.round(this.totalCommission / this.quotationModel.divMonth / 10) *
      //   10;

      // this.deviceMonthOriginPrice =
      //   Math.round((this.deviceDivMonthPrice - this.monthCommission) / 10) * 10;

      this.changeMonthEstimatedPrice =
        this.changeMonthPrice + this.deviceDivMonthPrice;
    },

    setPrice(policy) {
      const isCheap = this.isCheapPhone();

      if (policy === 1 || isCheap) {
        this.optionalAgreementMonthPrice = 0;
      } else {
        this.optionalAgreementMonthPrice = this.quotationModel.price * 0.25;
      }

      if (policy === 1 || isCheap) {
        this.optionalAgreementTotalPrice = 0;
      } else {
        this.optionalAgreementTotalPrice =
          this.optionalAgreementMonthPrice * 24;
      }

      this.monthPrice =
        this.quotationModel.price -
        this.optionalAgreementMonthPrice -
        this.welfareMoney;
      this.monthPrice = Math.round(this.monthPrice / 10) * 10;

      this.deviceDivMonthOriginPrice =
        this.quotationModel.factoryPrice -
        this.quotationModel.storeSupportMoney -
        (policy === 1 ? this.supportMoney : 0); //공시지원금(1)일 경우에만 -공시지원금

      this.deviceDivMonthOriginPrice =
        this.deviceDivMonthOriginPrice < 0 ? 0 : this.deviceDivMonthOriginPrice;

      this.deviceDivMonthPrice =
        (((this.deviceDivMonthOriginPrice * (this.interestRate / 100)) / 12) *
          Math.pow(
            1 + this.interestRate / 100 / 12,
            this.quotationModel.divMonth,
          )) /
        (Math.pow(
          1 + this.interestRate / 100 / 12,
          this.quotationModel.divMonth,
        ) -
          1);
      this.deviceDivMonthPrice = Math.round(this.deviceDivMonthPrice / 10) * 10;

      this.totalCommission =
        this.deviceDivMonthPrice * this.quotationModel.divMonth -
        this.deviceDivMonthOriginPrice;

      this.monthCommission =
        Math.round(this.totalCommission / this.quotationModel.divMonth / 10) *
        10;

      this.deviceMonthOriginPrice =
        Math.round((this.deviceDivMonthPrice - this.monthCommission) / 10) * 10;

      this.monthEstimatedPrice = this.monthPrice + this.deviceDivMonthPrice;
    },

    getTotalPrice(policy) {
      const deviceDivMonthOriginPrice =
        this.quotationModel.factoryPrice -
        this.quotationModel.storeSupportMoney -
        (policy === 1 ? this.supportMoney : 0); //공시지원금(1)일 경우에만 -공시지원금

      const optionalAgreementMonthPrice =
        policy === 1 ? 0 : this.quotationModel.price * 0.25;

      const totalCommission =
        Math.floor(
          (deviceDivMonthOriginPrice *
            Math.pow(1 + 0.059, this.quotationModel.divMonth) *
            0.059) /
            (Math.pow(1 + 0.059, this.quotationModel.divMonth) - 1) /
            10,
        ) * 10;

      let monthPrice = this.quotationModel.price - optionalAgreementMonthPrice;
      monthPrice = Math.round(monthPrice / 10) * 10;

      let deviceDivMonthPrice =
        (((deviceDivMonthOriginPrice * (this.interestRate / 100)) / 12) *
          Math.pow(
            1 + this.interestRate / 100 / 12,
            this.quotationModel.divMonth,
          )) /
        (Math.pow(
          1 + this.interestRate / 100 / 12,
          this.quotationModel.divMonth,
        ) -
          1);
      deviceDivMonthPrice = Math.round(this.deviceDivMonthPrice / 10) * 10;

      return monthPrice + deviceDivMonthPrice;
    },
  },
};
</script>

<style></style>
